<template>
    <div>
        <v-card elevation="0" class="contact-card">
            <v-card-title><v-icon>mdi-calendar-clock</v-icon>&nbsp;Your Cart Items</v-card-title>
            <v-card-subtitle>Please apply via the cart in <b>Browse Postings</b>.</v-card-subtitle>
            <v-card-text>
                <v-card elevation="0" color="white">
                    <v-card-text v-if="loading">
                        <v-progress-linear
                            indeterminate
                            rounded
                            height="4"
                            color="#4CD7D0"
                        ></v-progress-linear>
                    </v-card-text>
                    <v-card-text v-else>
                        <div v-if="items.length == 0">
                            <v-container style="height: 100px;">
                                <v-row
                                    class="fill-height"
                                    align-content="center"
                                    justify="center"
                                >
                                    <v-col
                                        class="text-subtitle-1 text-center"
                                        cols="12"
                                    >
                                        No items in cart
                                    </v-col>
                                </v-row>
                            </v-container>
                        </div>
                        <div v-else>
                            <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th rowspan="2">Title</th>
                                            <th rowspan="2">Discipline</th>
                                            <th rowspan="2">Type</th>
                                            <th rowspan="2" colspan="2">Posting Due</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in items" :key="item.title">
                                            <td>{{ item.title }}</td>
                                            <td>{{ item.discipline }}</td>
                                            <td>{{ item.type }}</td>
                                            <td>{{ item.due }} </td>
                                            <td><span v-if="item.daysleft != 0"><b>{{ item.daysleft }}</b> day&#40;s&#41; left</span><span v-else><b>Due today</b></span></td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import auth from '@/js/auth';

export default {
    data(){
        return{
            host: location.hostname.toString(),
            loading: true,
            items: []
        }
    },
    methods: {
        calculateRemainingDays(date){
            const MSPERDAY = 1000 * 60 * 60 * 24;
            let today = new Date();
            let due = new Date(date);
            let todayutc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
            let dateutc = Date.UTC(due.getFullYear(), due.getMonth(), due.getDate());

            return Math.floor((dateutc - todayutc) / MSPERDAY)+1;
        },
        getCartItems(){
            const that= this;
            that.loading = true;

            that.items = [];

            //Session Reading
            let uid = "";
            if(sessionStorage.getItem('cupeapp_aaa')){
                uid = auth.get_impersonated_user()["uid"];
                
            }else {
                uid = auth.get_user()["uid"];
            }

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getcart&data={"uid": "'+uid+'"}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        resultData.data.forEach(element => {
                            if(JSON.stringify(element["posting"]) != "{}"){
                                that.items.push({
                                    title: element["posting"]["title"],
                                    discipline: element["posting"]["discipline"],
                                    type: element["posting"]["type"],
                                    due: element["posting"]["endDate"],
                                    daysleft: that.calculateRemainingDays(element["posting"]["endDate"])
                                });
                            }
                        });

                        that.loading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
    },
    created(){
        const that = this;
        that. getCartItems();
    }
}
</script>
<style scoped>
.contact-card{
    background-color: #E0F2F1;
}
</style>